import { render, staticRenderFns } from "./PublishingContractsSplitsEditPanelDialog.vue?vue&type=template&id=8907c5a0"
import script from "./PublishingContractsSplitsEditPanelDialog.vue?vue&type=script&lang=js"
export * from "./PublishingContractsSplitsEditPanelDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports